module.exports = __webpack_public_path__ + "static/img/供应商.6c60c618.png";